import Vue from 'vue'
import Widget from './Widget.vue'
import vuetify from './plugins/vuetify'
import { createPinia, PiniaVuePlugin } from 'pinia';

Vue.config.productionTip = false

const rootID = '#cleverroute-widget'
const paramsEl = { ...document.querySelector(rootID).dataset }
window.CLEVERROUTE_HOST = paramsEl.cleverrouteHost

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

new Vue({
  vuetify,
  pinia,
  render: h => {
    const { hideDestination, ...params } = paramsEl
    return h(Widget, { props: { hideDestination, params } })
  },
}).$mount(rootID)
